import React from 'react'
import PropTypes from 'prop-types';
import { Link } from 'react-router'
import { FormattedMessage } from 'react-intl';

import AccountLogoutButton from '../../account/logout/logout-button'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'


// import TopToBottom from '../../components/animated/top-to-bottom'
// https://facebook.github.io/react/docs/two-way-binding-helpers.html
// fade in/out : http://stackoverflow.com/questions/33426539/react-animate-transition-between-components
// add dom element: http://blog.vjeux.com/2013/javascript/scroll-position-with-react.html

import './workspacePanel.styl'
import Button from '../button/button';

class WorkspacePanel extends React.Component {
    static TRANSITION_TIME = 500;

    constructor(props){
        super(props);
        this.state = {
            open: true
        }
    }

    UNSAFE_componentWillReceiveProps() {
        this.state = {
            open: true
        }
        this.setState(this.state)
    }

    close(e) {
        e.preventDefault();
        setTimeout(() => {
            this.props.history.push('');
        }, WorkspacePanel.TRANSITION_TIME);
        this.state.open = false;
        this.setState(this.state)
    }

    render() {
        let { componentClass=false, data=false } = this.props;
        let { open } = this.state;

        return (<ReactCSSTransitionGroup
            transitionName="workspacePanel-background"
            transitionEnterTimeout={WorkspacePanel.TRANSITION_TIME}
            transitionLeaveTimeout={WorkspacePanel.TRANSITION_TIME}>
            {data && componentClass && open && <div className="workspacePanel">
                <div className="workspacePanel-content">
                    { React.createElement(componentClass, {...data, close: this.close}) }
                </div>
                <div className="workspacePanel-close">
                    <AccountLogoutButton />
                    <Button icon="closeV2" label="app.close" onClick={this.close.bind(this)} />
                </div>
            </div>}
        </ReactCSSTransitionGroup>)
    }
}

WorkspacePanel.propTypes = {
    history: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    componentClass: PropTypes.func.isRequired
}

export default WorkspacePanel;
